import "./main.css";
import { useLanguage } from "./i18n";

export default function HomePage() {
  const { t } = useLanguage();
  return (
    <div className="bu-page">

      {/* HERO */}
      <section className="bu-main">
        <div className="bu-hero">
          <h1>{t("welcome")}</h1>
          <p>{t("underConstruction")}</p>

          <a
            href="https://wa.me/15717585005"
            target="_blank"
            className="bu-btn bu-whatsapp"
          >
            💬 {t("whatsappSupport")}
          </a>
        </div>
      </section>

    </div>
  );
}
